import { useLocalStorage } from '@vueuse/core'
import { defineStore } from 'pinia'
import { useTokenStore } from './TokenStore'
import { AgentApiPath, useHallApi } from '@99fun-agent/hooks'
import { computed } from 'vue'
import { useUserStore } from './UserStore'
import { useLinkStore } from './LinkStore'
/**
 * 用户认证Store
 */
export const useAuthStore = defineStore('authStore', () => {
  const _initData: {
    username: string
    password: string
    isRemember: boolean
    isLogout: boolean
  } = {
    username: '',
    password: '',
    isRemember: false,
    isLogout: true
  }

  const authStorage = useLocalStorage('__K__AUTH_DATA', _initData)
  const tokenStore = useTokenStore()
  const userStore = useUserStore()
  const linkStore = useLinkStore()

  const reset = () => {
    tokenStore.reset()
    userStore.reset()
    linkStore.reset()
  }
  const { setTokenExpiredProxy, setJwtProxy, post, authPost, get } = useHallApi()
  //设置网络请求的jwt token获取proxy
  setJwtProxy(() => {
    // console.error('获取token', tokenStore.token)
    return tokenStore.token
  })

  const isRemember = computed(() => authStorage.value.isRemember)
  const cacheUsername = computed(() => authStorage.value.username)
  const cachePassword = computed(() => authStorage.value.password)

  /**
   * 是否已登录
   */
  const isAlreadyLogin = computed<boolean>(() => {
    return !!tokenStore.token //&&!!userStore.uid
  })

  /**
   * 是否可以自动登陆
   */
  const isCanAutoLogin = computed<boolean>(() => {
    return (
      !!authStorage.value.isRemember &&
      !!authStorage.value.username &&
      !!authStorage.value.password &&
      !tokenStore.token &&
      !authStorage.value.isLogout
    )
  })
  /**
   * 是否可以自动登陆
   */
  const isHasLoginAccount = computed<boolean>(() => {
    return !!authStorage.value.username && !!authStorage.value.password && !tokenStore.token
  })

  /**
   * 请求登陆
   * @param reqData
   */
  const reqLogin = async (reqData: ILoginReq, isRemember: boolean) => {
    const r = await post<ILoginReply>(AgentApiPath.Login, reqData, {
      showLoading: true,
      showErrorCodeTip: true
    })

    if (r.isSuccess) {
      tokenStore.setToken(r.data?.token ?? '')
      tokenStore.setUid((r.data?.userId ?? 0) as number)
      authStorage.value.isRemember = isRemember
      if (isRemember) {
        authStorage.value.username = reqData.username ?? ''
        authStorage.value.password = reqData.password ?? ''
      } else {
        authStorage.value.username = ''
        authStorage.value.password = ''
      }

      await afterLogin()
    }

    return r
  }

  const reqModifyPassword = async (reqData: IModifyPasswordReq) => {
    const r = await post<any>(AgentApiPath.ModifyPassword, reqData, {
      showLoading: true,
      showErrorCodeTip: true
    })
    if (r.isSuccess) {
      authStorage.value.password = ''
      reqLogout()
    }
    return r
  }

  /**
   * 自动登录
   * @returns
   */
  const reqAutoLogin = async () => {
    return await reqLogin(
      {
        username: authStorage.value.username,
        password: authStorage.value.password
      },
      authStorage.value.isRemember
    )
  }

  const afterLogin = async () => {
    authStorage.value.isLogout = false
    console.log('afterLogin')
    userStore.reqUserInfo()
  }

  /**
   * 检查当前登录状态，如果登录了，则调用登录后接口，如果没登录，则判断请求自动登录
   * @returns
   */
  const checkToLogin = () => {
    if (!isAlreadyLogin.value && isCanAutoLogin.value) {
      //如果没有token信息，但是可以自动登录，则请求自动登录
      reqAutoLogin()
      return
    }

    if (isAlreadyLogin.value) {
      //如果已经登录，则请求登录需要立即请求的内容
      afterLogin()
    }
  }

  /**
   * 登出
   */
  const reqLogout = () => {
    console.log('执行退出')
    authStorage.value.isLogout = true
    reset()
  }

  return {
    reset,
    isCanAutoLogin,
    isHasLoginAccount,
    isAlreadyLogin,
    reqLogin,
    reqLogout,
    checkToLogin,
    isRemember,
    cachePassword,
    cacheUsername,
    reqModifyPassword
  }
})

export interface ILoginReq {
  /**
   * 用户名
   */
  username: string
  /**
   * 密码
   */
  password: string
}

export interface ILoginReply {
  /**
   * 用户id
   */
  userId: string
  /**
   * jwt token
   */
  token: string
}

export interface IModifyPasswordReq {
  /**
   * 老密码
   */
  originPassword: string
  /**
   * 新密码
   */
  newPassword: string
}
